import { combineReducers } from 'redux';
import globalReducer from './globalReducer';
import translationsReducer from './TranslationsReducer';
import propertiesReducer from './PropertiesPageReducer/propertiesReducer';
import resizeReducer from '../ui-components/ResizeHandler/redux/reducer';
import userDetailsReducer from './UserDetailsReducer';

const appReducer = combineReducers({
  globalReducer,
  propertiesReducer,
  translationsReducer,
  resizeReducer,
  userDetailsReducer
});

const rootReducer = (state, action) => {
  return appReducer(state, action);
};
export default rootReducer;
